import styled from 'styled-components';

export const LoadingWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 5rem;
`;

export const CardWrapper = styled.div`
  margin-bottom: -30px;
`;
